<template>
    <div>
        <div v-show="!loading">
            <div v-html="svg_loaded" class="text-center"></div>

            <template v-if="!loading">
                <template
                    v-if="! seccion.tiene_secciones && load_popover"
                >
                    <PopOverComponent
                        v-for="zona in zonas"
                        :key="zona.id" 
                        :zona="zona" 
                        :zona_id="zona_id" 
                        :libres="getAsientosLibres(zona)" 
                        :occupied="zona.id === zona_id"
                    />
                </template>                
                <b-popover v-else-if="load_popover" v-for="zona in zonas" :key="zona.id" :target="'popover-' + zona.id" triggers="hover focus">
                    <template slot="title">{{ zona.name }}</template>
                    <span v-if="!zona.esta_disponible && zona.tiene_precios">{{ $t('partidos.agotadas') }}</span>
                    <span v-else-if="!zona.esta_disponible && !zona.tiene_precios">{{ $t('mapa.no_disponible') }}</span>
                </b-popover>
            </template>
        </div>
        <template v-if="loading">
            <div class="col-12 text-center" style="height: 400px">
                <LoaderComponent/>
            </div>
        </template> 
    </div>
</template>

<script>
    import PopOverComponent from '@/components/svg/components/PopOverComponent.vue';

    export default {
        components: {PopOverComponent},
        props: ['zonas', 'event', 'sesion_id', 'zona_id', 'seccion'],
        data() {
            return {
                svg_loaded : '',
                loading: true,
                can_click: true,
                reg: null,
                load_popover: true
            }            
        },
        created() {
            this.getSvgCode();  

        
            let userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if(/windows phone/i.test(userAgent)) {
                this.load_popover = false;
            }

            if(/android/i.test(userAgent)) {
                this.load_popover = false;
            }

            if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                this.load_popover = false;
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        methods : {
            getAsientosLibres(zona) {
                if(zona.libres >= 0) {
                    return zona.libres;
                }

                if(zona.libres < 0) {
                    return 0;
                }

                var aforo = 0;

                if(!zona.with_seats) {
                    aforo = zona.aforo;
                } else {
                    aforo = zona.total_asientos;
                }

                aforo = aforo - zona.confirmados - zona.bloqueados - zona.no_confirmados - zona.sesion;

                if(aforo < 0) {
                    aforo = 0;
                }

                return aforo;
            },
            getSvgCode() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                    },
                    tid: this.configuracion.hash_teatro,
                    event_id: this.event.id,
                    sesion_id: this.sesion_id,
                    seccion_id: this.seccion.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.evento.sesion.secciones.seccion.svg'), params).then(res => {
                    this.loadSVG(res.data.svg);
                });
            },
            loadSVG(svg) {
                this.svg_loaded = svg;

                var vue_instance = this;

                setTimeout(() => {
                    var regions = document.getElementsByClassName("recinto-zona");

                    this.reg = regions;

                    for(var i in regions) {
                        if(regions[i].dataset !== undefined) {
                            var region_id = regions[i].dataset.region;

                            for(var j in this.zonas) {
                                if(this.zonas[j].id == region_id) {
                                    if (!this.zonas[j].esta_disponible) {
                                        regions[i].classList.add("plaza_ocupada");
                                        if(this.$route.name === 'back.events.sesion.bloquear-asientos' || this.$route.name === 'back.abonos.bloquear-asientos' || this.$route.name === 'back.abonos.index' || this.$route.name === 'back.abonados.show'  || this.$route.name === 'back.events.venta' || this.$route.name === 'superadmin.butacas.ocultar') {
                                            regions[i].addEventListener('click', function() {
                                                vue_instance.clickRegion(this.dataset.region);
                                            }, false);
                                        }
                                    } else {
                                        regions[i].addEventListener('click', function() {
                                            vue_instance.clickRegion(this.dataset.region);
                                        }, false);
                                    }
                                }
                            }
                        }                              
                    }
                    
                    this.loading = false;
                    this.$emit('cargado');
                }, 1000);                
            },
            clickRegion : function(region_id) {
                let zona = null;
                for(let i in this.zonas) {
                    if(this.zonas[i].id == region_id) {
                        zona = this.zonas[i];
                    }
                }

                if(zona) {
                    if(! this.seccion.tiene_secciones) {
                        if(this.can_click && zona.esta_disponible && this.getAsientosLibres(zona) > 0 && zona.precios.length > 0) {
                            this.$emit('clickZona', zona);
                        }

                        if(this.$route.name === 'back.events.sesion.bloquear-asientos' || this.$route.name === 'back.abonos.bloquear-asientos' || this.$route.name === 'back.abonos.index' || this.$route.name === 'back.abonados.show'  || this.$route.name === 'back.events.venta' || this.$route.name === 'superadmin.butacas.ocultar') {
                            this.$emit('clickZona', zona);
                        }
                    } else {
                        this.$emit('clickZona', zona);
                    }                
                }            
            }
        }
    }
</script>